import moment from "moment";

export const formatTime = (time) => {
  if (!time) return "-";
  return moment(time).format("hh:mm A");
};

export const trackingTabs = [
  {
    label: "Attendance Logs",
    value: "attendance-logs",
  },
  {
    label: "Out of Range Logs",
    value: "location-logs",
  },
  // {
  //   label: "Break Logs",
  //   value: "break-logs",
  // },
  {
    label: "Break Rules",
    value: "break-rules",
  },
];

// Status options for filter
export const STATUS_OPTIONS = [
  // { label: "All Status", value: "" },
  { label: "Within Range", value: "within_range" },
  { label: "Out of Range", value: "out_of_range" },
];

// GPS Status options for filter
export const GPS_STATUS_OPTIONS = [
  { label: "All GPS Status", value: "" },
  { label: "GPS Enabled", value: "1" },
  { label: "GPS Disabled", value: "0" },
];

// Location Status options for filter
export const LOCATION_STATUS_OPTIONS = [
  { label: "All Location Status", value: "" },
  { label: "Within Range", value: "within_range" },
  { label: "Out of Range", value: "out_of_range" },
];

// Get GPS status color
export const getGpsStatusColor = (status) => {
  return status === "1" || status === 1
    ? { bg: "#28a745", color: "#fff" }
    : { bg: "#dc3545", color: "#fff" };
};

// Get location status color
export const getLocationStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "within_range":
    case "in_range":
      return { bg: "#28a745", color: "#fff" };
    case "out_of_range":
    case "out_range":
      return { bg: "#dc3545", color: "#fff" };
    default:
      return { bg: "#6c757d", color: "#fff" };
  }
};

// Format distance
export const formatDistance = (distance) => {
  if (!distance) return "-";
  const dist = parseFloat(distance);
  if (dist >= 1000) {
    return `${(dist / 1000).toFixed(2)} km`;
  }
  return `${dist.toFixed(0)} m`;
};

export const TrackingTimeFormat = (time) => {
  if (!time) return "-";
  const m = moment(time);
  if (!m.isValid()) return "-";
  return m.format("hh:mm A");
};

export const TrackingTimeFormatVisual = (time) => {
  if (!time) return "-";
  // Handles "HH:mm" or "HH:mm:ss" or full datetime
  // If time is already in "HH:mm" or "HH:mm:ss", parse as today
  let m;
  if (/^\d{2}:\d{2}$/.test(time)) {
    m = moment(time, "HH:mm");
  } else if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
    m = moment(time, "HH:mm:ss");
  } else {
    m = moment(time);
  }
  if (!m.isValid()) return "-";
  return m.format("hh:mm A");
};
